/**
 * Authenticated HTTP client for Digitalconnect SSRM grid endpoints (host copy).
 */
import BaseService from '@/services/BaseService';

export class SsrmGatewayService extends BaseService {
  constructor() {
    super('/api/digitalconnect-service');
  }
}
